import { memo, useEffect, useState } from "react";
import { Controller } from "react-hook-form";

type TagInputProps = {
  control: any;
  name: string;
  addclass?: string;
  defaultValue?: string[]; // ✅ Default value support added
};

const TagInput: React.FC<TagInputProps> = memo(
  ({ control, name, addclass, defaultValue = [] }) => {
    const [tags, setTags] = useState<string[]>([]);
    useEffect(() => {
      if (defaultValue.length > 0) {
        setTags(defaultValue);
      }
    }, [defaultValue]);
    const addTag = (
      e: React.KeyboardEvent<HTMLInputElement>,
      onChange: (value: string[]) => void
    ) => {
      if (e.key === "Enter" && (e.target as HTMLInputElement).value.trim()) {
        e.preventDefault();
        const newTag = (e.target as HTMLInputElement).value.trim();

        // ✅ Latest state update
        setTags((prevTags) => {
          const updatedTags = [...prevTags, newTag];
          onChange(updatedTags); // ✅ Update form state
          return updatedTags;
        });

        (e.target as HTMLInputElement).value = "";
      }
    };

    const removeTag = (index: number, onChange: (value: string[]) => void) => {
      setTags((prevTags) => {
        const updatedTags = prevTags.filter((_, i) => i !== index);
        onChange(updatedTags); // ✅ Remove hone ke baad form state update ho raha hai
        return updatedTags;
      });
    };

    return (
      <Controller
        control={control}
        name={name}
        rules={{ required: "At least one tag is required" }}
        render={({ field: { onChange }, fieldState: { error } }) => (
          <div>
            <div className={`border p-2 rounded w-full flex items-center ${addclass} min-h-11 bg-white text-sm`}>
              <div className="flex flex-wrap gap-2 w-full">
                {tags.map((tag, index) => (
                  <div
                    key={index}
                    className="bg-darkCyan text-white px-2 py-1 rounded flex items-center "
                  >
                    {tag}
                    <button
                      type="button"
                      className="ml-2 text-white"
                      onClick={() => removeTag(index, onChange)}
                    >
                      ✕
                    </button>
                  </div>
                ))}
                <input
                  type="text"
                  className="border-none focus:outline-none caret-primary w-full"
                  placeholder="Add tag..."
                  onKeyDown={(e) => addTag(e, onChange)}
                />
              </div>
            </div>
            {error && <p className="text-red-500 text-sm mt-1">{error.message}</p>}
          </div>
        )}
      />
    );
  }
);

export default TagInput;
